export type WpRequestVariables = {
  slug?: string;
  lang?: string;
  limit?: number;
  category?: number | string;
  offset?: number;
  order?: string;
  orderby?: string;
};

export const WpClientRequest = async ({
  post_type = "",
  variables = {},
  isContent = true,
  isForms = false,
  forceUpdate = false,
  liveOnly = false,
}: {
  post_type: string;
  variables?: WpRequestVariables;
  isContent?: boolean;
  isForms?: boolean;
  forceUpdate?: boolean;
  liveOnly?: boolean;
}) => {
  const requestObject = JSON.stringify({
    post_type,
    variables,
    isContent,
    isForms,
    // ignore this terms
    // forceUpdate,
    // liveOnly,
  });

  const res = await fetch(`/api/findContent?${new URLSearchParams({filter: requestObject }).toString()}`, {
    // 14400 sec = 4h
    next: { revalidate: 14400, tags: ["wp_content"] },
    // cache: 'force-cache'
  });

  return await res.json();
};
